import { styles } from "./Style.js";

export function Portfolio(props) {
    return (<div></div>)
}